import { render, staticRenderFns } from "./FineRecordAdd.vue?vue&type=template&id=1ce0ac22&scoped=true"
import script from "./FineRecordAdd.vue?vue&type=script&lang=js"
export * from "./FineRecordAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce0ac22",
  null
  
)

export default component.exports